var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 408,
    viewBox: "0 0 457 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M25.8203 42.6086L40.0205 126.53L104.568 80.0499L25.8203 42.6086Z",
    fill: "url(#paint0_linear_517_9410)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M25.8203 42.6087L51.6385 0L104.568 80.05L25.8203 42.6087Z",
    fill: "url(#paint1_linear_517_9410)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M51.6384 0L104.568 80.05L210.427 24.5326L51.6384 0Z",
    fill: "url(#paint2_linear_517_9410)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M418.271 220.785L450.544 326.659L375.67 244.026L418.271 220.785Z",
    fill: "url(#paint3_linear_517_9410)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M0 265.976L41.3117 180.759L95.5325 259.52L0 265.976Z",
    fill: "url(#paint4_linear_517_9410)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M289.175 269.848L375.67 244.026L320.158 188.504L289.175 269.848Z",
    fill: "url(#paint5_linear_517_9410)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M347.269 51.6458L457 95.5436L320.158 188.504L347.269 51.6458Z",
    fill: "url(#paint6_linear_517_9410)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M375.67 244.026L418.271 220.785L320.158 188.504L375.67 244.026Z",
    fill: "url(#paint7_linear_517_9410)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M418.271 220.785L457 95.5435L320.158 188.504L418.271 220.785Z",
    fill: "url(#paint8_linear_517_9410)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M104.568 80.0501L210.427 24.5327L189.772 77.4675L104.568 80.0501Z",
    fill: "url(#paint9_linear_517_9410)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M289.175 269.848L320.158 188.504L206.554 202.709L289.175 269.848Z",
    fill: "url(#paint10_linear_517_9410)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M289.175 269.848L375.67 244.026L317.578 387.341L289.175 269.848Z",
    fill: "url(#paint11_linear_517_9410)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M375.67 244.026L450.544 326.659L317.578 387.341L375.67 244.026Z",
    fill: "url(#paint12_linear_517_9410)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M347.27 51.6457L457 95.5435L406.653 5.16528L347.27 51.6457Z",
    fill: "url(#paint13_linear_517_9410)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M189.772 77.4673L206.554 202.709L281.431 100.709L189.772 77.4673Z",
    fill: "url(#paint14_linear_517_9410)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M189.772 77.4675L210.428 24.5327L281.431 100.709L189.772 77.4675Z",
    fill: "url(#paint15_linear_517_9410)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M206.554 202.709L320.158 188.504L281.431 100.709L206.554 202.709Z",
    fill: "url(#paint16_linear_517_9410)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M210.427 24.5326L289.175 7.74561L281.431 100.709L210.427 24.5326Z",
    fill: "url(#paint17_linear_517_9410)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M289.175 7.74561L347.269 51.6456L281.431 100.709L289.175 7.74561Z",
    fill: "url(#paint18_linear_517_9410)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M320.158 188.504L347.269 51.6458L281.431 100.709L320.158 188.504Z",
    fill: "url(#paint19_linear_517_9410)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M40.0205 126.531L41.3116 180.759L117.477 198.835L40.0205 126.531Z",
    fill: "url(#paint20_linear_517_9410)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M40.0205 126.53L104.568 80.05L117.477 198.835L40.0205 126.53Z",
    fill: "url(#paint21_linear_517_9410)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M41.3118 180.759L95.5326 259.52L117.477 198.835L41.3118 180.759Z",
    fill: "url(#paint22_linear_517_9410)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M104.568 80.0499L189.772 77.4673L117.477 198.835L104.568 80.0499Z",
    fill: "url(#paint23_linear_517_9410)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M189.772 77.4673L206.554 202.709L117.477 198.835L189.772 77.4673Z",
    fill: "url(#paint24_linear_517_9410)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M95.5325 259.52L117.477 198.835L163.951 303.417L95.5325 259.52Z",
    fill: "url(#paint25_linear_517_9410)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M95.5325 259.52L123.933 364.102L163.951 303.417L95.5325 259.52Z",
    fill: "url(#paint26_linear_517_9410)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M117.477 198.835L206.554 202.709L163.951 303.417L117.477 198.835Z",
    fill: "url(#paint27_linear_517_9410)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M123.933 364.102L209.136 408L163.951 303.417L123.933 364.102Z",
    fill: "url(#paint28_linear_517_9410)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M206.554 202.709L289.175 269.848L163.951 303.417L206.554 202.709Z",
    fill: "url(#paint29_linear_517_9410)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M0 265.976L95.5325 259.52L37.4383 312.456L0 265.976Z",
    fill: "url(#paint30_linear_517_9410)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M95.5324 259.52L123.933 364.102L37.4382 312.456L95.5324 259.52Z",
    fill: "url(#paint31_linear_517_9410)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M163.951 303.417L209.136 408L276.266 358.937L163.951 303.417Z",
    fill: "url(#paint32_linear_517_9410)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M163.951 303.417L289.175 269.848L276.266 358.937L163.951 303.417Z",
    fill: "url(#paint33_linear_517_9410)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M289.175 269.848L317.578 387.341L276.266 358.937L289.175 269.848Z",
    fill: "url(#paint34_linear_517_9410)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_517_9410",
    x1: 20.5875,
    y1: 48.1831,
    x2: 104.341,
    y2: 126.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B75FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_517_9410",
    x1: 21.828,
    y1: 4.12381,
    x2: 101.869,
    y2: 82.8613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA43A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB46A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_517_9410",
    x1: 52.7051,
    y1: -0.538079,
    x2: 117.06,
    y2: 127.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF4DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_517_9410",
    x1: 382.21,
    y1: 211.535,
    x2: 482.037,
    y2: 282.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD41AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C176BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_517_9410",
    x1: -13.5614,
    y1: 192.848,
    x2: 71.1032,
    y2: 287.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#991096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92018F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_517_9410",
    x1: 275.314,
    y1: 201.572,
    x2: 356.508,
    y2: 287.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A834A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5FB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_517_9410",
    x1: 309.18,
    y1: 62.6165,
    x2: 446.039,
    y2: 199.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B75FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_517_9410",
    x1: 319.773,
    y1: 188.723,
    x2: 367.366,
    y2: 272.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B95CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_517_9410",
    x1: 328.972,
    y1: 87.4741,
    x2: 453.729,
    y2: 223.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_517_9410",
    x1: 104.488,
    y1: 24.4905,
    x2: 150.159,
    y2: 111.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B45AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B255B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_517_9410",
    x1: 227.205,
    y1: 173.712,
    x2: 304.209,
    y2: 281.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0229E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD41AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_517_9410",
    x1: 296.286,
    y1: 232.277,
    x2: 423.087,
    y2: 308.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A436A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B75FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_517_9410",
    x1: 298.873,
    y1: 264.219,
    x2: 441.782,
    y2: 396.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B65CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A231A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_517_9410",
    x1: 348.002,
    y1: 4.55347,
    x2: 436.708,
    y2: 112.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B050AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4BAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_517_9410",
    x1: 189.714,
    y1: 77.5458,
    x2: 309.091,
    y2: 164.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A834A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD41AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_517_9410",
    x1: 178.967,
    y1: 33.4375,
    x2: 253.858,
    y2: 123.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B75FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE6EBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_517_9410",
    x1: 196.882,
    y1: 109.411,
    x2: 298.289,
    y2: 222.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B148AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B552B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_517_9410",
    x1: 226.594,
    y1: -11.257,
    x2: 318.291,
    y2: 66.4191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA67B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_517_9410",
    x1: 273.683,
    y1: 18.7564,
    x2: 361.376,
    y2: 80.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC48AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE6EBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_517_9410",
    x1: 291.125,
    y1: 31.5454,
    x2: 398.054,
    y2: 82.9858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3EAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C278C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_517_9410",
    x1: 25.82,
    y1: 139.788,
    x2: 97.9522,
    y2: 217.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C176BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA39A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_517_9410",
    x1: 48.5717,
    y1: 66.9087,
    x2: 157.269,
    y2: 137.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE6EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_517_9410",
    x1: 50.4958,
    y1: 171.261,
    x2: 129.211,
    y2: 247.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A32AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A32AA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_517_9410",
    x1: 107.845,
    y1: 72.941,
    x2: 221.985,
    y2: 153.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B964B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_517_9410",
    x1: 114.011,
    y1: 82.4547,
    x2: 232.316,
    y2: 166.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C176BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F1F9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_517_9410",
    x1: 91.0939,
    y1: 205.62,
    x2: 186.917,
    y2: 268.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A227A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_517_9410",
    x1: 95.4536,
    y1: 259.64,
    x2: 191.274,
    y2: 322.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B152AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#981A95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_517_9410",
    x1: 128.271,
    y1: 186.163,
    x2: 231.519,
    y2: 274.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A834A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B964B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_517_9410",
    x1: 121.568,
    y1: 306.298,
    x2: 223.992,
    y2: 389.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC6CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB46A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_517_9410",
    x1: 143.282,
    y1: 219.309,
    x2: 241.65,
    y2: 341.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A227A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B964B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_517_9410",
    x1: 9.32228,
    y1: 254.312,
    x2: 54.2099,
    y2: 335.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF71BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_517_9410",
    x1: 40.9945,
    y1: 255.167,
    x2: 143.721,
    y2: 340.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B357B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F2A9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_517_9410",
    x1: 160.343,
    y1: 306.778,
    x2: 264.656,
    y2: 418.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A02C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92018F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_517_9410",
    x1: 183.416,
    y1: 255.934,
    x2: 267.583,
    y2: 374.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_517_9410",
    x1: 271.672,
    y1: 282.967,
    x2: 345.205,
    y2: 308.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA67B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA67B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImg);
export default __webpack_public_path__ + "static/media/authImg.31cbc08816200fc7dc496a2ad5d0f525.svg";
export { ForwardRef as ReactComponent };